import { ElNotification } from 'element-plus';

type Position = 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';

function notifyInfo(message: string, position?: Position) {
  if (!message) return;

  ElNotification({
    title: '提示',
    message,
    type: 'info',
    position: position || 'top-right',
  });
}

export default notifyInfo;
